var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGooglePlayMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "30 10 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 10.6c-.3.3-.4.8-.4 1.4v22.1c0 .6.2 1.1.5 1.4l.1.1L43 23.2V23L30.4 10.6z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientA)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 27.4l-4.1-4.1V23l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientB)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 27.3l-4.2-4.2-12.5 12.5c.5.5 1.2.5 2.1.1l14.6-8.4z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientC)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1 18.9l-14.6-8.3c-.9-.5-1.6-.4-2.1.1l12.5 12.4 4.2-4.2z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientD)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientA",
    x1: 41.8,
    y1: 11.81,
    x2: 25.017,
    y2: 28.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientB",
    x1: 53.834,
    y1: 23.101,
    x2: 29.637,
    y2: 23.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientC",
    x1: 44.826,
    y1: 25.396,
    x2: 22.068,
    y2: 48.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientD",
    x1: 27.296,
    y1: 3.276,
    x2: 37.459,
    y2: 13.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

export default SvgGooglePlayMark;